export const socialsData = {
    github: 'https://github.com/WillMcX',
    // facebook: 'https://www.facebook.com/',
    linkedIn: 'https://www.linkedin.com/in/william-mccoy-3027a7282',
    instagram: 'https://www.instagram.com/will.e_mc/?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D',
    // codepen: 'https://codepen.io/',
    // twitter: 'https://twitter.com/',
    // reddit: 'https://www.reddit.com/user/',
    // blogger: 'https://www.blogger.com/',
    // medium: 'https://medium.com/@',
    // stackOverflow: 'https://stackoverflow.com/users/',
    // gitlab: 'https://gitlab.com/',
    // youtube: 'https://youtube.com/',
}